<template>
  <div>
    <div class="maintitle">{{ $route.meta.title }}</div>
    <el-divider></el-divider>
    <el-row :gutter="10" class="text-left">
      <el-col :span="6">
        <el-select v-model="type" style="width:100%" @change="getList">
          <el-option v-for="(item,index) in typeList" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-table :data="list" border>
      <el-table-column prop="department" label="部门"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="title" label="类型"></el-table-column>
      <el-table-column prop="score" label="得分"></el-table-column>
      <el-table-column :formatter="formatStatus" label="状态"></el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button @click="setStatus(scope,2)" type="primary" v-if="scope.row.status === 1">同意</el-button>
          <el-button @click="setStatus(scope,1)" type="danger" v-else>取消</el-button>
          <el-button @click="showList(scope)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="listDiv" :show-close="false" :close-on-click-modal="false">
      <el-table :data="pingshenList" border>
        <el-table-column prop="name" label="评审人"></el-table-column>
        <el-table-column prop="score" label="评分"></el-table-column>
        <el-table-column label="详情">
          <template v-slot="scope">
            <el-button @click="showDetail(scope)" type="text">查看分项得分</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :visible.sync="detailDiv" :show-close="false" :close-on-click-modal="false" append-to-body>
        <el-table :data="pingshenInfo" border :tree-props="{ children: 'children' }" row-key="id" default-expand-all>
          <el-table-column prop="title" label="考核内容"></el-table-column>
          <el-table-column label="理由">
            <template v-slot="scope">
              <span style="white-space: pre-wrap">{{ scope.row.beizhu }}</span>
            </template>
          </el-table-column>
          <el-table-column label="分值" prop="score" width="100"></el-table-column>
          <el-table-column label="评分" prop="point">
            <template v-slot="scope">
              <span :class="scope.row.score === scope.row.point?'':'text-danger strong'">{{scope.row.point}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="detailDiv = false;">关闭</el-button>
        </div>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="listDiv = false;">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list:[],
      type:'',
      typeList:[],
      detailDiv:false,
      listDiv:false,
      pingshenList:[],
      pingshenInfo:[]
    }
  },
  methods: {
    getList(){
      this.list = [];
      if(this.type === ''){
        this.$message({
          type:'warning',
          message:'请选择员工岗位'
        })
        return;
      }
      this.$axios({
        url:this.HOST+'/kaohe/finalass/getExcellent',
        method:'post',
        data:{
          type:this.type,
        }
      }).then((res) => {
        if(res.data.status === 1) {
          this.list = res.data.list;
        }
      })
    },
    setStatus(scope,status){
      this.$axios({
        url:this.HOST+'/kaohe/finalass/setExcellentStatus',
        method:'post',
        data:{
          id:scope.row.id,
          status:status
        }
      }).then((res) => {
        if(res.data.status === 1) {
          this.getList()
        }
      })
    },
    formatStatus(row){
      return row.status === 1?'待审':'通过'
    },
    showList(scope){
      this.$axios({
        url:this.HOST+'/kaohe/finalass/getPingshenList',
        method:'post',
        data:{
          uuid:scope.row.uuid,
        }
      }).then((res) => {
        if(res.data.status === 1) {
          this.pingshenList = res.data.list;
          this.listDiv = true;
        }
      })
    },
    showDetail(scope){
      this.$axios({
        url:this.HOST+'/kaohe/finalass/getPingshenDetail',
        method:'post',
        data:{
          id:scope.row.eid,
          leader:scope.row.leader
        }
      }).then((res) => {
        if(res.data.status === 1) {
          this.pingshenInfo = res.data.list;
          this.detailDiv = true;
        }
      })
    }
  },
  mounted() {
    this.$axios({
      url:this.HOST+'/kaohe/index/getCommonInfo',
      method:'post',
      data:{
        info:['employeeType'],
      }
    }).then((res)=>{
      if(res.data.status === 1){
        this.typeList = res.data.employeeType;
      }
    })
  }
}
</script>